import { Format } from './Format';
export const FormatPluginID = 'format';
export const formatPlugin = {
    id: FormatPluginID,
    component: Format
};
